import $store from "@/store";
import { VUE_APP_WS_URL } from "@utils";

const Socket = function() {
  this.ws = new WebSocket(VUE_APP_WS_URL);
  console.log("ws open0");
  console.log(VUE_APP_WS_URL)
  this.ws.onopen = this.onOpen.bind(this);
  this.ws.onerror = this.onError.bind(this);
  this.ws.onmessage = this.onMessage.bind(this);
  this.ws.onclose = this.onClose.bind(this);
};

Socket.prototype = {
  vm(vm) {
    this.vm = vm;
  },
  close() {
    clearInterval(this.timer);
    this.ws.close();
  },
  onOpen: function() {
    console.log("ws open1");
    this.init();
    this.vm.$emit("socket_open");
  },
  init: function() {
    var that = this;
    this.timer = setInterval(function() {
      that.send({ type: "ping" });
      console.log("ping");
    }, 150000);
  },
  send: function(data) {
    return this.ws.send(JSON.stringify(data));
  },
  onMessage: function(res) {
    //  console.log("连接数据：")
    //  console.log(JSON.parse(res.data))
    if (res.data=="pong") {
      return;
    }
    
    this.vm.$emit("onMessage", JSON.parse(res.data));
  },
  onClose: function() {
    console.log("ws open2");
    clearInterval(this.timer);
  },
  onError: function(e) {
    console.log("ws open3");
    console.log(e);
    this.vm.$emit("socket_error", e);
  }
};

Socket.prototype.constructor = Socket;

export default Socket;

